// extracted by mini-css-extract-plugin
export var modalFooter = "_j6-0";